import { useCallback } from 'react';

import IconClose from 'approot/shared/icons/icon-close';
import { DeleteHandler } from 'approot/shared/content/content.constants';
import { AnyObject } from 'webclient.constants';
import { DeleteStyled } from './delete.style';

type Props = {
  name: string;
  content: AnyObject;
  handleDelete?: DeleteHandler;
  disabled?: boolean;
  disabledMessage?: string;
  handleDisabledDelete?: () => void;
};

const Delete = ({
  content,
  disabled,
  disabledMessage,
  handleDisabledDelete,
  handleDelete,
}: Props) => {
  const handleClick = useCallback(() => {
    if (disabled && handleDisabledDelete) {
      handleDisabledDelete();
    } else if (handleDelete) {
      handleDelete(content.id);
    }
  }, [content.id, disabled, handleDisabledDelete, handleDelete]);

  return (
    <DeleteStyled
      onClick={handleClick}
      title={(disabled && disabledMessage) || 'Delete'}
      data-selector="delete"
      $isDisabled={disabled}
    >
      <IconClose width={15} height={15} />
    </DeleteStyled>
  );
};

export default Delete;
